
import './style.scss'
import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { userStateData } from '../../data/userStateData';
import { interactionConnector } from '../../server/connector/interactionConnector';
import { PAGE_URLS } from '../../constants/hrefLinks';
import Footer from '../../sections/footer/Footer';
import HeaderSolid from '../../sections/header/HeaderSolid';
import CtaButton from '../../components/ctaButton/CtaButton';
import { VideoUploadResponse } from '../../server/types';
import { API_URL } from '../../constants/pathConstants';
import { ChatMessage } from '../../types/types';
import { setShowWatchVideos } from '../../redux/reducers/chatSlice';
import WatchVideo from '../../components/watchVideo/WatchVideo';
import { MAX_VIDEO_FILE_SIZE } from '../../constants/constants';

const MIN_MESSAGE_WORD_COUNT: number = 25
const MAX_MESSAGE_WORD_COUNT: number = 250

function CreateInteraction() {
	const loginChecked: boolean = useAppSelector(state => state.user.loginChecked)
	const showWatchVideos: boolean = useAppSelector(state => state.chat.showWatchVideos)

	const [uploadingVideo, setUploadingVideo] = useState<boolean>(false)
	const [creatingInteraction, setCreatingInteraction] = useState<boolean>(false)
	const [uploadErrorMessage, setUploadErrorMessage] = useState<string>('')
	// const [uploadErrorWithRetry, setUploadErrorWithRetry] = useState<boolean>(false)
	const [messageLengthGood, setMessageLengthGood] = useState<boolean>(false)

	const [videoPaths, setVideoPaths] = useState<string[]>([])
	const [initialMessage, setInitialMessage] = useState<string>('')

	// const fileSizeLimitBytes: number = 100971520 // 20971520 // 971520 // 20971520

	const dispatch = useAppDispatch()

	useEffect(() => {
		// check if log in has been checked and confirmed in App.tsx
		if (loginChecked == true) {
			// confirm a user is logged in
			if (userStateData.loggedIn === false || userStateData.isAnInstructor()) {
				window.location.replace(PAGE_URLS.SEARCH)
			} else {
				const querySting: string = window.location.search;
				const urlParams: URLSearchParams = new URLSearchParams(querySting)
				const instructorId: string | null = urlParams.get('instructorId')

				if (!instructorId) {
					window.location.replace(PAGE_URLS.SEARCH)
				}
			}
		}
	}, [loginChecked])

	const uploadFile = (file: File) => {
		// console.log("Uploading file...")
		setUploadErrorMessage('')
		setUploadingVideo(true)
		// if (file.size > fileSizeLimitBytes) {
		if (file.size > MAX_VIDEO_FILE_SIZE) {
			// setUploadErrorMessage(`Sorry, This file is to large to upload, size limit is ${Math.round(fileSizeLimitBytes / 1024 / 1024)} mb`)
			setUploadErrorMessage(`Sorry, This file is to large to upload, size limit is ${Math.round(MAX_VIDEO_FILE_SIZE / 1024 / 1024)} mb`)
			setUploadingVideo(false)
		} 
		else if (file.type.match('video.*')) {
			const API_ENDPOINT = `${API_URL}upload-video`
			const request = new XMLHttpRequest()
			const formData = new FormData()

			request.open("POST", API_ENDPOINT, true)
			request.onreadystatechange = () => {
				console.log(request)
				if (request.readyState === 4 && request.status === 200) {
					console.log(request.responseText)
					const responseObj: VideoUploadResponse = JSON.parse(request.responseText)
					if (responseObj.error) {
						setUploadingVideo(false)
						setUploadErrorMessage(`Upload Failed: ${responseObj.error}`)
					} else if (responseObj.fileName) {
						setUploadErrorMessage('')
						videoAdded(responseObj.fileName)
					}
				} else {
					setUploadErrorMessage('Sorry, Upload Failed - Connection Error! please try again or refresh the page')
					setUploadingVideo(false)
				}
			}
			formData.append("file", file);
			request.send(formData);
		} else {
			setUploadErrorMessage(`Sorry, it appears that isn't a Video. Only video can be added. Please try again and let us know if you're uploading a video and seeing this message, Thank you`)
			setUploadingVideo(false)
		}
	}

	const videoAdded = (fileName: string) => {
		setUploadingVideo(false)
		setVideoPaths([...videoPaths, fileName])
	}

	const createNewInteraction = () => {
		const querySting: string = window.location.search;
		const urlParams: URLSearchParams = new URLSearchParams(querySting)
		const instructorId: string | null = urlParams.get('instructorId')
		const interactionCost: string | null = urlParams.get('cost')

		if (!instructorId || !interactionCost) {
			window.location.replace(PAGE_URLS.SEARCH)
		} else {
			if (interactionConnector.requestInProgress) {
				console.log('[CreateInteraction] - createNewInteraction() called while requestInProgress')
			} else {
				// interactionConnector.performCreateInteractionRequest(instructorId, userStateData.getId()).then((requestStatus) => {
				let chatMessages: ChatMessage[] = []
				videoPaths.forEach((path: string) => {
					chatMessages.push({
						message: path,
						type: 'video',
						sourceId: '1',
						time: Date.now().toString(),
						profileImgUrl: userStateData.getUserIconUrl() as string
					})
				})
				chatMessages.push({
					message: initialMessage,
					type: 'txt',
					sourceId: '1',
					time: Date.now().toString(),
					profileImgUrl: userStateData.getUserIconUrl() as string
				})
				interactionConnector.performCreateVideoInteractionRequest(
					instructorId,
					userStateData.getId(),
					JSON.stringify({messages: chatMessages}),
					interactionCost
				).then((requestStatus) => {
					if (!requestStatus) {
						console.log('[CreateInteraction] - createNewInteraction() call failed')
					}
					// window.location.replace(`${PAGE_URLS.DASHBOARD_CUSTOMER}`)
					window.location.replace(userStateData.transactionUrl)
				})
			}
		}
	}

	const videoClickHandler = (fileName: string) => {
		userStateData.setVideoFileName(fileName)
		dispatch(setShowWatchVideos(true))
	}

	const removeVideoClickHandler = (fileIndex: number) => {
		let newList: string[] = []
		videoPaths.forEach((path: string, index: number) => {
			if (fileIndex !== index) {
				newList.push(path)
			}
		})
		setVideoPaths(newList)
	}

	const payNowClickHandler = () => {
		setCreatingInteraction(true)
		createNewInteraction()
	}

	const messageOnChange = (newValue: string) => {
		setInitialMessage(newValue)
		setMessageLengthGood(newValue.split(' ').length > MIN_MESSAGE_WORD_COUNT && newValue.split(' ').length < MAX_MESSAGE_WORD_COUNT)
	}

	return (
		<>
			{/* {showWatchVideos && <WatchVideo videoUrls={[]} />} */}
			{showWatchVideos && <WatchVideo />}
			<div className='section-wrap section-seperator'>
				<HeaderSolid />
			</div>
			<div className='section-wrap section-seperator'>
				<div className='section-content'>
					<div className='upload-content'>
						<div className='upload-info-wrap'>
							<div className='upload-info-content'>
								<div className='upload-info-title'>Upload Videos</div>
								<div className='upload-info-sub-text'>Add up to 3 videos for review along with a message for the Instructor</div>
							</div>
						</div>
						<div className='upload-video-wrap'>
							{videoPaths.map((videoPath: string, index: number) =>
								<div
									className='upload-mini-video'
									key={`video${index}`}
								>
									<img
										className='upload-mini-video-play-icon'
										src='/imgs/icons/icon-play-circle.svg'
										alt='Play'
										onClick={() => {
											videoClickHandler(videoPath)
										}}
									/>
									<img
										className='upload-mini-video-remove-icon'
										src='/imgs/icons/icon-delete-x.svg'
										alt='Remove'
										onClick={() => {
											removeVideoClickHandler(index)
										}}
									/>
								</div>
							)}
						</div>
						{uploadingVideo && 
							<div className='upload-video-wrap'>
								Uploading...
								<img
									src='/imgs/misc/spinner.svg'
									className='upload-spinner'
									alt='spinner'
								/>
							</div>
						}
						{!uploadingVideo && videoPaths.length < 3 &&
							<label
								className='upload-add-video-button'
							>
								<input
									type='file'
									id='videoFile'
									name='videoFile'
									onChange={(event) => {
										if (event.target.files && event.target.files.length > 0) {
											uploadFile(event.target.files[0])
										}
									}}
									accept='video/*,image/*'
									disabled={uploadingVideo || creatingInteraction}
								/>
								<img
									src='/imgs/icons/icon-faq-plus.svg'
									className='upload-add-video-img'
									alt='Add video'
								/>
							</label>
						}
						{uploadErrorMessage != '' && 
							<div className='upload-video-error-txt'>
								{uploadErrorMessage}
							</div>}
						{!uploadingVideo &&
							<>
								<textarea
									className='dashboard-content-area-chat-input-input dashboard-content-area-chat-input-textarea'
									placeholder='Include an initial message along with your videos'
									value={initialMessage}
									onChange={(evt) => {
										messageOnChange(evt.target.value)
									}}
									disabled={uploadingVideo || creatingInteraction}
								/>
								{!messageLengthGood && initialMessage.length > 0 && 
									<div className='dashboard-warning-message-txt m-l-20'>
										Message must be at least {MIN_MESSAGE_WORD_COUNT} words and no more than {MAX_MESSAGE_WORD_COUNT}
									</div>
								}
							</>
						}
						<div className='upload-button-wrap'>
							<CtaButton
								label='Pay Now'
								onClick={() => payNowClickHandler()}
								size='medium'
								disabled={uploadingVideo || initialMessage === '' || videoPaths.length < 1 || creatingInteraction || !messageLengthGood}
							/>
						</div>
					</div>
				</div>
			</div>
			<div className='section-wrap section-seperator'>
				<div className='section-content'>
					<Footer />
				</div>
			</div>
		</>
	)
}

export default CreateInteraction
